import { styled } from '@mui/material/styles'
import { ToggleButtonProps, ToggleButton } from '@mui/material'

export const FilterButton = styled(ToggleButton)<ToggleButtonProps>(
  ({ theme }) => ({
    backgroundColor: theme.palette.common.white,
    boxShadow: '3px 3px 8px 0px #0909094D',
    border: 'none',
    fontWeight: 700,
    fontSize: '16px',
    borderRadius: '20px',
    paddingLeft: '12px',
    paddingRight: '12px',

    maxHeight: '40px',
    textTransform: 'none',
    '& .Mui-selected': {
      bgcolor: theme.palette.primary.main,
    },
    '&:hover': {
      backgroundColor: theme.palette.common.white,
      '&.Mui-selected': {
        backgroundColor: theme.palette.primary.main,
      },
      '&:active': {
        boxShadow:
          '3px 3px 8px 0px #0909094D,inset 8px 6px 4px rgba(0,0,0, 0.1)',
      },
    },
    '&.Mui-selected': {
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.main,
      },
    },
    [theme.breakpoints.up('sm')]: {
      minWidth: '56px',
    },
  })
)
export default FilterButton
